// extracted by mini-css-extract-plugin
module.exports = {"main":"feed-page_main__3BLq8","container":"feed-page_container__1D70E","loader":"feed-page_loader__3VKsj"};